import api from "!../../../../../../node_modules/.pnpm/style-loader@2.0.0_webpack@5.101.3/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../../../../node_modules/.pnpm/css-loader@5.2.7_webpack@5.101.3/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[3].use[1]!../../../../../../node_modules/.pnpm/postcss-loader@4.3.0_postcss@8.4.31_webpack@5.101.3/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[3].use[2]!../../../../../../node_modules/.pnpm/sass-loader@10.2.0_sass@1.39.0_webpack@5.101.3/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[3].use[3]!./AppControls.scss";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};